import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDocumentosRecusados = (): TabelaColuna => ({
  Chave: 'documentosRecusados',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Doc. Recusados</div>
})
